// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__37953","header":"PatientQuestionnaire_header__3fqLw","info":"PatientQuestionnaire_info__38N9Q"};